export default __webpack_public_path__ + "img/22.f676ba5c.jpg";